<script>
    import { onMount, getContext } from "svelte";
    import { shouldResetRebateTableDropdowns } from './resetStore';

    import Select from "svelte-select/Select.svelte";
    import {
        deleteIcon
    } from "../../../Utils/utilConstants.svelte";
    import {
        addErrorInput,
        removeErrorInput,
    } from "../../../Pages/PatientEncounter/helpers/encounterUtils.svelte";

    export let itemNums = [], rebateType, unitValue, upliftRebate, mbsItems = [], selectedInsuranceFund, identifier, hospitalFundNoGapProgramNames;
    export let onRemove = () => {};
    export let onRebateTypeChange = () => {};

    let errInputs = [];

    $: if ($shouldResetRebateTableDropdowns) {
        rebateTableValue = null;
        upliftRebate = null;

        shouldResetRebateTableDropdowns.set(false);
    }

    export const checkNoGapProgramRuleValidation = () => {
        errInputs = [];

        if(!rebateTypeValue){
            errInputs = addErrorInput(
                `${identifier}-selectedRebateType`,
                errInputs,
                "Selected rebate type",
            );
        }

        if(rebateType == 1) {
            if(!unitValue) {
                errInputs = addErrorInput(
                    `${identifier}-ruleUnitValue`,
                    errInputs,
                    "Rebate unit value",
                );
            }
        }
        if(rebateType == 2) {
            if(upliftRebate == null || upliftRebate == undefined) {
                errInputs = addErrorInput(
                    `${identifier}-ruleRebateTable`,
                    errInputs,
                    "Rebate table",
                );
            }
        }

        //check items only for special rules
        if(onRemove != null){
            if( !selectedItems || selectedItems.length == 0){
                errInputs = addErrorInput(
                    `${identifier}-ruleItems`,
                    errInputs,
                    "Rule items",
                );
            }
        }
       

        return errInputs;
    };

    const rebateTypes = [   
        {
            key: 1,
            value: "Unit value"
        }
    ]

    if(hospitalFundNoGapProgramNames.length > 0){
        rebateTypes.push( {
            key: 2,
            value: "Uplift certain item numbers"
        });
    }

    let rebateTypeValue = null;
    let rebateTableValue = null;
    let selectedItems = [];

    onMount(() => {
        if(itemNums.length > 0){
            selectedItems = mbsItems.filter(i => itemNums.includes(i.itemNum));
        }
        if(rebateType != null){
                rebateTypeValue = rebateTypes.find(r => r.key == rebateType);
        }
        if(upliftRebate != null){
            rebateTableValue = hospitalFundNoGapProgramNames.find((r) => r.key == upliftRebate);
        }
    });

</script>

<div class="w-full flex flex-row items-center gap-2">
    <div class="w-full flex flex-col gap-2">
        <div class="flex-1 flex flex-row justify-evenly gap-2">
            
            <div class="flex-1 min-w-0 rounded-md" id={`${identifier}-selectedRebateType`}>
                <Select
                    bind:value={rebateTypeValue}
                    items={rebateTypes}
                    itemId="key"
                    label="value"
                    on:change={(ev) => { 
                        rebateTypeValue = ev.detail; 
                        rebateType = ev.detail.key; 
    
                        if(rebateType == 2) {
                            //uplift
                            unitValue = 0;
                        }
                        if(rebateType == 1) {
                            //unit value
                            upliftRebate = null;
                            unitValue = 50;
                        }
                        
                        onRebateTypeChange(ev.detail); 
                        errInputs = removeErrorInput(
                            `${identifier}-selectedRebateType`,
                            errInputs,
                            "Selected rebate type"
                        );
                    }}
                    on:clear={() => { rebateType = null; }}
                    placeholder="Rebate type"
                />
            </div>
            <div class="flex-1 min-w-0">
                {#if rebateType == null || rebateType == 0}
                    <input
                        type="number"
                        disabled={true}
                        placeholder={`Select rebate type`}
                        class="input w-full input-sm input-bordered h-10"
                        autocomplete="off"
                    />
                {/if}
                {#if rebateType == 1}
                    <input
                        id={`${identifier}-ruleUnitValue`}
                        type="number"
                        placeholder={`$ Unit Value`}
                        class="input w-full input-sm input-bordered h-10"
                        autocomplete="off"
                        on:focus={() => {
                            errInputs = removeErrorInput(
                                `${identifier}-ruleUnitValue`,
                                errInputs,
                                "Rebate unit value",
                            );
                        }}
                        bind:value={unitValue}
                    />
                {/if}
                {#if rebateType == 2}
                    <div class="w-full rounded-md" id={`${identifier}-ruleRebateTable`}>
                        <Select
                            bind:value={rebateTableValue}
                            items={hospitalFundNoGapProgramNames}
                            itemId="key"
                            label="label"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            menuPlacement="auto"
                            on:change={(ev) => {
                                rebateTableValue = ev.detail;
                                upliftRebate = ev.detail.key;
                                errInputs = removeErrorInput(
                                    `${identifier}-ruleRebateTable`,
                                    errInputs,
                                    "Rebate table",
                                );
                            }}
                            on:clear={() => { upliftRebate = null; }}
                            noOptionsMessage="No rebate table found"
                            placeholder="Select rebate table"
                        />
                    </div>
                {/if}
            </div>
        </div>
        {#if onRemove != null}
            <div class="flex-1 flex flex-row">
                    <div class="flex-1 min-w-0 rounded-md" id={`${identifier}-ruleItems`}>
                        <Select
                            bind:value={selectedItems}
                            items={mbsItems}
                            multiple={true}
                            itemId="itemNum"
                            label="itemNum"
                            on:clear={() => {
                                selectedItems = [];
                                itemNums = [];
                            }}
                            on:change={(ev) => {
                                if(ev.detail.length > 0){
                                    itemNums = ev.detail.map(i => i.itemNum);
                                }
                                errInputs = removeErrorInput(
                                    `${identifier}-ruleItems`,
                                    errInputs,
                                    "Rule items"
                                );
                            }}
                            noOptionsMessage="No item found"
                            placeholder="Select items"
                        />
                    </div>
            </div>
        {/if}
    </div>
    
    {#if onRemove != null}
        <div class="flex items-center pr-2">
            <div on:click={onRemove} class="deleteIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center cursor-pointer w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Remove rule">
                <i class="deleteIcon {deleteIcon}"></i>
            </div>
        </div>
    {/if}
    
</div>


